export const FAVORITES_SEARCH_BUTTON_ID = 'favorites-search-button';
export const FAVORITES_CARD_BUTTON_SELECTOR = '[data-favorites-card-button]';
export const FAVORITES_ONBOARDING_STORAGE_KEY =
  'free-avia:favorites-onboarding';
